import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, { FunctionComponent, useRef, useEffect } from 'react';
import { toDateStringFullMonthName } from '../../util/format';
import './DatePicker.css';

// type FauxEvent = {
//   target: {
//     name: string
//     value: string | any
//   }
// }

interface DatePickerProps {
  name: string;
  label: string;
  format?: string;
  onChange: any;
  [propKey: string]: any;
  onloadFocus?: boolean;
  mask?: string;
}

class CustomFormatUtils extends DateFnsUtils {
  getDatePickerHeaderText(date: Date) {
    return toDateStringFullMonthName(date);
  }
}

const DatePicker: FunctionComponent<DatePickerProps | any> = React.forwardRef(
  (props: any, ref?: React.Ref<HTMLInputElement>) => {
    const {
      onChange,
      name,
      label,
      format = 'MM/dd/yyyy',
      labelShrink,
      mask,
    } = props;
    const [selectedDate, setSelectedDate] = React.useState<any>(null);
    const handleDateChange = (date: any, value: string) => {
      setSelectedDate(date);
      onChange({
        target: {
          name,
          value,
        },
      });
    };

    return (
      <MuiPickersUtilsProvider utils={CustomFormatUtils}>
        <KeyboardDatePicker
          disableToolbar
          DialogProps={{
            className: 'date-picker-dialog',
          }}
          margin="normal"
          id={`date-picker-${name}`}
          name={name}
          label={label}
          format={format}
          inputVariant="outlined"
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          placeholder={'MM/DD/YYYY'}
          {...props}
          value={selectedDate || props.value || null}
          onChange={handleDateChange as any}
          mask={mask}
          InputLabelProps={labelShrink}
          autoOk={true}
        />
      </MuiPickersUtilsProvider>
    );
  },
);

export default DatePicker;
